import React, { Component } from 'react'
import { connect } from 'react-redux';
import cx from 'classnames';

import AppConfig from '../../AppConfig';

import {
  getActiveFrame,
  getBookCover,
  getViewMode,
  getIsAudioBook
} from '../../store/selectors/selectors'
import './style.scss';


const {
  VIEWER_MODES: {
    LISTEN_MODE
  }
} = AppConfig;

class Poster extends Component {


  render() {
    const {
      posterUrl,
      activeFrame,
      isAudioMode,
      isAudioBook,
    } = this.props;

    const componentClassName = 'poster-viewer'
    const classNames = cx(componentClassName, {
      [componentClassName + '--is-hidden']: activeFrame !== -1 && !isAudioMode && !isAudioBook
    });

    return (
      posterUrl
      ? <div
        className={classNames}
        style={{ backgroundImage: `url(${posterUrl})` }}
      />

      : null
    )
  }
}



const mapStateToProps = state => {
  return {
    activeFrame: getActiveFrame(state),
    posterUrl: getBookCover(state),
    isAudioMode: getViewMode(state) === LISTEN_MODE,
    isAudioBook: getIsAudioBook(state),
  }
};


export default connect(mapStateToProps)(Poster);




// WEBPACK FOOTER //
// ./src/containers/poster/Poster.jsx